// Eager slim slice of the marketplace component barrel (#16).
//
// The full `./index.js` barrel `export *`s all 45 marketplace component files
// (the whole MarketplaceIsland UI tree, MarketplaceDetailModal, MarketplaceGrid,
// every *Section, the community feed, prompt gallery, …) — ~274KB that the
// unified shell dragged into its EAGER chunk via
// `import * from '../marketplace/components/index.js'` in workspace/context.js.
//
// Marketplace is now a lazy sub-app: the `/marketplace*` routes fold the FULL
// marketplace context into the live shell context on first mount
// (workspace/pages/index.js → lazySharedLib). So every marketplace UI key those
// routes reference resolves against the folded context — none of it needs to be
// eager.
//
// The shell's ONLY eager reference into the marketplace component barrel is the
// shell-root install modal: app.js polls `root.installModal` and, when set,
// opens a windows-API layer whose content is `{ extends: 'MarketplaceInstallModal' }`
// (~app.js:1156). That extends must resolve at the shell root regardless of fold
// state, so MarketplaceInstallModal + its transitive bare-key deps live here:
//   MarketplaceInstallModal.js also exports MarketplaceInstallConfigField,
//     MarketplaceInstallScopeStep, MarketplaceInstallConfigStep,
//     MarketplaceInstallCatalogError (one file, self-contained).
//   MarketplaceInstallModal `extends: 'IntegrationLogo'` for its header icon.
// Every function these components el.call (marketplaceHostOf, closeInstallModal,
// submitInstallModal, selectItemFresh, getKindAccent, hasIntegrationLogo, …)
// fires only at mount/interaction — the modal is only ever opened AFTER a
// marketplace surface folds the context — so those resolve via the fold (with
// closeInstallModal also carried in functions/eagerSlice.js as a direct backstop).
//
// marketplace/package.json has no `sideEffects: false`, so a re-export through
// `./index.js` would NOT tree-shake (referencing it evaluates every sibling
// source file). Each key below is therefore `export *`-ed from its SOURCE file
// directly, so only these two light modules ride the eager chunk.
export * from './MarketplaceInstallModal.js'
export * from './IntegrationLogo.js'
// THE ONE CATALOGUE's row (the shell's AppsCatalogueTabs — Workspace apps ·
// App Store, ledger AS-3) extends the store's segment look and is drawn by the
// shell's EAGER /apps page, so the look rides the eager chunk too — one small,
// self-contained file with no function of its own.
export * from './MarketplaceSegment.js'
